import React from 'react';
import { FlexWrapper, HeaderText, Value } from '../AnimatedList/styles';

export default ({ title, value }) =>
  <FlexWrapper>
    <HeaderText>{title}</HeaderText>
    <Value>{value}</Value>
  </FlexWrapper>;
